export interface RuntimeConfig {
  REACT_APP_API_URL: string
}

const DEFAULT_API_URL = '/api'

let config: RuntimeConfig = {
  REACT_APP_API_URL: DEFAULT_API_URL,
}

function normalizeConfig(runtimeConfig: Partial<RuntimeConfig>): RuntimeConfig {
  return {
    REACT_APP_API_URL:
      import.meta.env.VITE_API_URL ||
      runtimeConfig.REACT_APP_API_URL ||
      DEFAULT_API_URL,
  }
}

export async function loadConfig(): Promise<RuntimeConfig> {
  let runtimeConfig: Partial<RuntimeConfig> = {}

  try {
    const response = await fetch('/config.json', { cache: 'no-store' })
    if (response.ok) {
      runtimeConfig = await response.json()
    }
  } catch (err) {
    console.warn('Failed to load runtime config, using Vite env fallback:', err)
  }

  config = normalizeConfig(runtimeConfig)
  return config
}

export function getConfig(): RuntimeConfig {
  return config
}

export function getApiUrl(): string {
  return import.meta.env.VITE_API_URL || config.REACT_APP_API_URL || DEFAULT_API_URL
}
